let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ekyg6")).then(() => parcelRequire('aqygr'));